
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const ComputerEducation = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Computer Education</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Academics</li>
                    <li>|</li>
                    <li>Computer Education</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="comp-blk">
                                <p>In today's world, information and technology get the pick of the bunch. Man is out-fashioned without the knowledge of computer. Also, now the time has come when every person seeking employment either in private or govt. sectors inevitably finds. Himself/herself, confronted with the need to be computer oriented and literate in computer science to meet the challenges of the time.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="comp_img">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/com-edu.gif" className="img-fluid" alt="st francis school, amritsar" /></LazyLoad>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="comp-blk">
                                <p>Students must be exposed to the computer environment at a younger age, when they are at the primary learning stage and when their ability to grasp is high. Exposure to computers at this stage of life will certainly help them in future, no doubt for a better career in the computer field, engineering etc.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ComputerEducation
